/** 搜索接口类型与既有埋点口径：默认词搜索仍归为普通搜索。 */
export const SEARCH_TYPE_LABELS = {
  1: '普通搜索',
  2: 'Recently Searched',
  3: '普通搜索',
  4: 'Popular Searches',
} as const;

export type SearchType = keyof typeof SEARCH_TYPE_LABELS;

/** 兼容缺少来源类型的旧链接，沿用搜索按钮的普通搜索兜底口径。 */
export function normalizeSearchType(value: string | null | undefined): SearchType {
  const type = Number(value);
  return type === 1 || type === 2 || type === 3 || type === 4 ? type : 1;
}
